module.exports = __webpack_public_path__ + "static/media/Pear.9f3fc0f3.png";